import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MoviesService {


  movies:any[] 
  constructor() 
  {
  
    this.movies = 
    [
      {
        id:1 , 
        movieName:"KUNG FU PANDA 3" ,
        year:"(2016)", 
        type:["ACTION","ADVENTURE","ANIMATION"] , 
        dircetor:["Alessandro Carloni","Jennifer Yuh"],
        tagline:["The weight is over Continuing his “legendary adventures of awesomeness”", "Po must face two hugely epic, but different threats: one supernatural and the other a little closer to his home."], 
        meanImage:"mean",
        slider:['slide3','slide2','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Cycles Demoreel 2015" , 
        tailerURL:"https://www.youtube.com/embed/wDRTjzLNK0g" , 
        duration:"90 MIN" , 
        folder:"KUNG"  , 
        stars:["Jack Black", "Dustin Hoffman", "David Cross", "James Hong"] , 
        rating:"9.1" , 
        reviews:[
          {
            name:"Jake" , 
            email:"Jake@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:5 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Alex" , 
            email:"Alex@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:3 , 
            date:" January 19, 2016 at 6:12 pm"
          } , 
          {
            name:"Andrew" , 
            email:"Andrew@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:5 , 
            date:" January 19, 2016 at 8:30 pm"
          } 

        ]
      } , 
      {
        id:2,
        movieName:"FINEST HOURS " , 
        year:"(2016)",
        folder:"FINEST"  , 
        type:["DRAMA","THRILLER"] , 
        dircetor:["Craig Gillespie"],
        tagline:["32 survivors, room for 12.","The Coast Guard makes a daring rescue attempt off the coast of Cape Cod after after a pair of oil tankers are destroyed during a blizzard in 1952."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Blender Demo Reel 2013" , 
        tailerURL:"https://www.youtube.com/embed/1XZGulDxz9o" , 
        duration:"117 MIN" , 
        rating:"8.2" , 
        stars:["Chris Pine","Ben Foster", "Casey Affleck", "Eric Bana"] , 
        reviews:[
          {
            name:"Daniel" , 
            email:"Daniel@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:5 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Adam" , 
            email:"Adam@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:3 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]
      } , 
      {
        id:3 ,
        movieName:"REVENANT " ,
        year:'(2015)'  ,  
        folder:"REVENANT"  , 
        type:["ADVENTURE","THRILLER" ,"DRAMA"]  , 
        dircetor:["Alejandro González Iñárritu"],
        tagline:["(n. One who has returned, as if from the dead.)","In the 1820s, a frontiersman, Hugh Glass, sets out on a path of vengeance against those who left him for dead after a bear mauling."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Elephants Dream" , 
        tailerURL:"https://www.youtube.com/embed/8yASbM8M2vg" , 
        duration:"156 MIN" , 
        rating:"7.5" , 
        stars:["Leonardo DiCaprio " , "Tom Hardy", "Will Poulter", "Domhnall Gleeson"] , 
        reviews:[
          {
            name:"Isaac" , 
            email:"Isaac@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:3 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Edward" , 
            email:"Edward@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:4 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]
      } , 

      
      {
        id:4 ,
        movieName:"RIDE ALONG 2 " ,
        year:'(2016)'  ,  
        folder:"RIDE"  , 
        type:["ACTION", "COMEDY"]  , 
        dircetor:["Tim Story"],
        tagline:["The brothers-in-law are back","As his wedding day approaches, Ben heads to Miami with his soon-to-be brother-in-law James to bring down a drug dealer who’s supplying the dealers of Atlanta with product."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Cycles Demoreel 2014" , 
        tailerURL:"https://www.youtube.com/embed/EJed22ShxLc" , 
        duration:"135" , 
        rating:"7.4" , 
        stars:[" Kevin Hart", "Ice Cube ", "Olivia Munn ", "Tika Sumpter"] , 
        reviews:[
          {
            name:"William" , 
            email:"William@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:3 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Joshua" , 
            email:"Joshua@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:5 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]
      } , 

      {
        id:5,
        movieName:"HATEFUL EIGHT " ,
        year:'(2015)'  , 
        folder:"HATEFUL"  ,  
        type:["MINDRAMA", "MYSTERY", "THRILLER"]  , 
        dircetor:["Quentin Tarantino"],
        tagline:["No one comes up here without a damn good reason.","Bounty hunters seek shelter from a raging blizzard and get caught up in a plot of betrayal and deception."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Blender Siggraph 2011 reel (Revised)" , 
        tailerURL:"https://www.youtube.com/embed/gwqSi_ToNPs" , 
        duration:"168 MIN" , 
        rating:"8.2" , 
        stars:["Samuel L. Jackson", "Kurt Russell", "Walton Goggins", "Jennifer Jason Leigh"] , 
        reviews:[
          {
            name:"Jack" , 
            email:"Jack@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:3, 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Jacob" , 
            email:"Jacob@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:2 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]

      } , 
      {
        id:6 ,
        movieName:"STAR WARS: THE FORCE AWAKENS" ,
        year:'(2015)'  ,  
        folder:"STAR"  ,  
        type:[ "MINACTION", "ADVENTURE", "FANTASY"]  , 
        dircetor:["J.J. Abrams"],
        tagline:["Every generation has a story.","Thirty years after defeating the Galactic Empire, Han Solo and his allies face a new threat from the evil Kylo Ren and his army of Stormtroopers."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Blender Siggraph 2011 reel (Revised)" , 
        tailerURL:"https://www.youtube.com/embed/wDRTjzLNK0g" , 
        duration:"135 MIN" , 
        rating:"8.9" , 
        stars:["Daisy Ridley", "John Boyega", "Adam Driver", "Harrison Ford"] ,
        reviews:[
          {
            name:"Oliver" , 
            email:"Oliver@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:5 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Jack" , 
            email:"Jack@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:5 , 
            date:" January 19, 2016 at 6:12 pm"
          } , 
          {
            name:"Jack" , 
            email:"Jack@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:4 , 
            date:" January 20, 2016 at 9:00 pm"
          }
        ]

      } , 

      {
        id:7 ,
        movieName:"THE MAN FROM U.N.C.L.E." ,
        year:'(2015)'  ,  
        folder:"MAN"  ,  
        type:[ "ACTION", "ADVENTURE", "COMEDY"]  , 
        dircetor:["Guy Ritchie"],
        tagline:["Saving the world never goes out of style.At the height of the Cold War, a mysterious criminal organization plans to use nuclear weapons and technology to upset the fragile balance of power between the United States and Soviet Union. CIA agent Napoleon Solo and KGB agent Illya Kuryakin are forced to put aside their hostilities and work together to stop the evildoers in their tracks. The duo’s only lead is the daughter of a missing German scientist, whom they must find soon to prevent a global catastrophe."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Blender Demo Reel 2013" , 
        tailerURL:"https://www.youtube.com/embed/1XZGulDxz9o" , 
        duration:"116 MIN" , 
        rating:"7.4" , 
        stars:["Henry Cavill", "Armie Hammer", "Alicia Vikander", "Elizabeth Debicki"] ,
        reviews:[
          {
            name:"Mima" , 
            email:"Mima@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:3 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Andrew" , 
            email:"Andrew@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:4 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]
      
      } , 

      {
        id:8 ,
        movieName:"MISSION: IMPOSSIBLE – ROGUE NATION." ,
        year:'(2015)'  ,  
        folder:"MISSION"  ,  
        type:[ "ACTION", "ADVENTURE", "COMEDY"]  , 
        dircetor:["Christopher McQuarrie"],
        tagline:["Go rogue Ethan and team take on their most impossible mission yet, eradicating the Syndicate – an International rogue organization as highly skilled as they are, committed to destroying the IMF."] , 
        meanImage:"mean",
        slider:['slide1','slide2','slide3','slide4','slide5'] , 
        tailerImage:'tailer' , 
        tailerNmae:"Cycles Demoreel 2014" , 
        tailerURL:"https://www.youtube.com/embed/EJed22ShxLc" , 
        duration:"131 MIN" , 
        rating:"7.5" ,
        stars:["Tom Cruise", "Jeremy Renner", "Simon Pegg", "Rebecca Ferguson"] ,
        reviews:[
          {
            name:"Andrew" , 
            email:"Andrew@yahoo.com" , 
            comment:"The fact that the relentless barrage of this humor is occasionally punctuated with pointedly insincere homilies wherein" , 
            stars:4 , 
            date:"January 18, 2016 at 7:20 pm"
          },
          {
            name:"Kouti" , 
            email:"jon@yahoo.com" , 
            comment:"The movie’s editing ADD is so severe that the aforementioned roofie-ing gag (actually a variation thereof, with Xanax substituting for Rohypnol" , 
            stars:2 , 
            date:" January 19, 2016 at 6:12 pm"
          }
        ]
      
      
      } , 


    ]

    
   
   }

  
  
}
